var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-btn-dropdown",
        {
          staticStyle: { "text-align": "right" },
          attrs: {
            size: "0.8rem",
            flat: "",
            dense: "",
            "no-caps": "",
            label: _vm.field.FieldNameAsDisplayed,
            color: "primary",
            align: "right"
          }
        },
        [
          _c(
            "q-list",
            [
              _vm.field.FieldDescription
                ? _c(
                    "q-item",
                    {
                      directives: [
                        { name: "close-overlay", rawName: "v-close-overlay" }
                      ]
                    },
                    [
                      _c("q-item-side", {
                        attrs: { icon: "info", color: "primary" }
                      }),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v(_vm._s(_vm.field.FieldDescription))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ]
                },
                [
                  _c("q-item-side", {
                    attrs: { icon: "web", color: "primary" }
                  }),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(_vm._s(_vm.field.Name))
                      ]),
                      _c("q-item-tile", { attrs: { sublabel: "" } }, [
                        _vm._v("[" + _vm._s(_vm.field.FieldOID) + "]"),
                        _vm.field.FieldEditor &&
                        _vm.field.FieldEditor !== "None"
                          ? _c("span", [
                              _vm._v(
                                " edytor: " + _vm._s(_vm.field.FieldEditor)
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ]
                },
                [
                  _c("q-item-side", {
                    attrs: { icon: "folder", color: "primary" }
                  }),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.field.FieldType) +
                            "\n          "
                        )
                      ]),
                      _c("q-item-tile", { attrs: { sublabel: "" } }, [
                        _vm._v("[" + _vm._s(_vm.field.FieldTypeID) + "]"),
                        _vm.field.IsMemo
                          ? _c("span", [_vm._v(" (tekst/opis/lista)")])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }